import classNames from "classnames";
import { Calendar, ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";
import { getFormattedLocale } from "@/features/calendar/model";
import type { Dayjs } from "dayjs";
import { CalendarHeader } from "../calendar-header";
import { CellRender } from "../cell-render";
import { useCellWidth } from "./hooks";
import styles from "./styles.module.scss";

export const CalendarViewDesktop = () => {
  const { i18n } = useTranslation();
  const { calendarRef, cellWidth } = useCellWidth();

  return (
    <div className={styles.root} ref={calendarRef}>
      <ConfigProvider locale={getFormattedLocale(i18n.language)}>
        <Calendar
          className={classNames(styles.calendar, styles["calendar-ru"])}
          headerRender={({ value, onChange }) => (
            <CalendarHeader value={value} onChange={onChange} />
          )}
          fullCellRender={(value: Dayjs) => <CellRender date={value} cellWidth={cellWidth} />}
        />
      </ConfigProvider>
    </div>
  );
};
